import { useSections } from "@/contexts/classified";
import { useMemo } from "react";
/**
 * Hook to get the medium 768 x 560 images
 *
 * @returns Medium images or null if no image
 */
export const useMediumImages = () => {
    var _a, _b;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const images = (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.gallery) === null || _b === void 0 ? void 0 : _b.images;
    const mediumImages = useMemo(() => {
        if (!images || images.length < 1)
            return null;
        return images.map((image) => {
            if (!(image === null || image === void 0 ? void 0 : image.url))
                return image;
            const urlMedium = new URL(image.url);
            urlMedium.searchParams.set("w", "768");
            urlMedium.searchParams.set("h", "560");
            return {
                ...image,
                id: image === null || image === void 0 ? void 0 : image.key,
                url: urlMedium.href,
            };
        });
    }, [images]);
    return mediumImages;
};
